import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { TranslocoService } from '@jsverse/transloco';
import {
  IGlobalAnnouncement,
  IGlobalAnnouncementSearchRequest
} from '@core/interfaces/iglobal-announcement';

@Injectable({
  providedIn: 'root'
})
export class GlobalAnnouncementService {
  private readonly base = 'GlobalAnnouncement';

  constructor(private dataService: DataService, private translocoService: TranslocoService) { }

  getActive(stateId?: number | null): Observable<IGlobalAnnouncement[]> {
    const params = stateId != null ? `?stateId=${stateId}` : '';
    return this.dataService.get(`${this.base}/active${params}`);
  }

  getById(id: number): Observable<IGlobalAnnouncement> {
    return this.dataService.get(`${this.base}/${id}`);
  }

  search(request: IGlobalAnnouncementSearchRequest): Observable<IGlobalAnnouncement[]> {

    return this.dataService.post(`${this.base}/search`,request);
  }

  add(request: IGlobalAnnouncement): Observable<boolean> {
    return this.dataService.post(`${this.base}`, request, this.translocoService.translate('configuration.globalAnnouncements.createdToast'));
  }

  update(request: IGlobalAnnouncement): Observable<boolean> {
    return this.dataService.put(`${this.base}`, request, this.translocoService.translate('configuration.globalAnnouncements.updatedToast'));
  }

  delete(id: number): Observable<boolean> {
    return this.dataService.delete(`${this.base}/${id}`, this.translocoService.translate('configuration.globalAnnouncements.deletedToast'));
  }
}
